/**
 * Check links on page and apply inter or external link class
 */

const checkLinks = {
  init: () => {
    // Get Links in main content
    const main = document.querySelector('.entry-content');
    const pageLinks = main.querySelectorAll('a');

    pageLinks.forEach((link) => {
      // If link is external:
      if (checkLinks.isExternalLink(link.href)) {
        // And has target=_blank but no external class
        if (
          link.getAttribute('target') === '_blank' &&
          !link.classList.contains('external-link-button') &&
          link.classList.contains('btn')
        ) {
          // Just add Class
          link.classList.add('external-link-button');
          // Or does not have target=_blank
        } else if (
          !link.classList.contains('external-link-button') &&
          link.classList.contains('btn')
        ) {
          // Add class and target attribute
          link.classList.add('external-link-button');
          link.setAttribute('target', '_blank');
        } else {
          link.setAttribute('target', '_blank');
        }
      }
    });
  },
  // Check if provided url is external or internal link
  isExternalLink: (url) => {
    const tmp = document.createElement('a');
    tmp.href = url;
    return tmp.host !== window.location.host;
  },
};

export default checkLinks;
